// eslint-disable-next-line no-var
var hj;

export const triggerHotjar = (event: string) => {
  if (hj) {
    hj('trigger', event);
  }
};
